import React, { useState } from 'react';
import Header from './components/Header';

const BaseLayout = ({ children }) => {
    const [error, setError] = useState(window.flash.error);
    const [success, setSuccess] = useState(window.flash.success);

    const isHaveMessages = !!error?.length || !!success?.length;
    
    return (
        <div className="menu-container sticky-menu-container">
            {/* Font Awesome  */}
            <link href="https://use.fontawesome.com/releases/v6.2.0/css/all.css" rel="stylesheet" />

            {/* Font Family Exo 2  */}
            <link href="https://fonts.googleapis.com/css?family=Exo+2&display=swap" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap" rel="stylesheet"/>

            <Header />

            {isHaveMessages && (
                <div className="d-flex flex-column" style={{ gap: '1rem' }}>
                    {error?.map(e => (
                        <div className="alert alert-danger">{e}</div>
                    ))}

                    {success?.map(s => (
                        <div className="alert alert-success">{s}</div>
                    ))}
                </div>
            )}
            
            {children}
        </div>
    );
};

export default BaseLayout;
